import { writable } from 'svelte/store';
import { getSharedStore, setSharedStore } from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/stores/shared.js?1733898722551';
import { logger } from '@wyvr/generator/universal.js';

export const clerk_name = 'clerk';

function loadClerk() {
    // token is always null on server, no token available
    if (false) {
        return null;
    }

    let store = getSharedStore(clerk_name);
    if (store) {
        return store;
    }

    const { subscribe, set } = writable(false);

    let token;
    let is_loading = false;

    store = {
        load: (api_token) => {
            if (!api_token) {
                logger.error('missing clerk api token');
                return;
            }
            // avoid loading the same api_token
            if (token === api_token) {
                return;
            }
            // avoid adding new token, when it is not ready
            if (is_loading) {
                return;
            }
            token = api_token;
            // add clerk script
            if (!window.Clerk) {
                is_loading = true;
                (function (w, d) {
                    var e = d.createElement('script');
                    e.type = 'text/javascript';
                    e.async = true;
                    e.src = (d.location.protocol == 'https:' ? 'https' : 'http') + '://cdn.clerk.io/clerk.js';
                    var s = d.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(e, s);
                    w.__clerk_q = w.__clerk_q || [];
                    w.Clerk =
                        w.Clerk ||
                        function () {
                            w.__clerk_q.push(arguments);
                        };
                })(window, document);
                Clerk('config', {
                    key: token
                });
            }
            // add interval until the script is available
            const interval = setInterval(() => {
                if (window.Clerk) {
                    clearInterval(interval);
                    set(true);
                    loading = false;
                }
            }, 100);
        },
        subscribe
    };
    return setSharedStore(clerk_name, store);
}

export const clerk = loadClerk();
